import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Layout from "../../layouts";
import Header from "../../components/header";
import Contact from "../../components/contact";
import Callout from "../../components/callout";
var _default = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(_default, _React$Component);
    function _default() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = _default.prototype;
    _proto.render = function render() {
        var _this$props$data$unsp, _this$props$data$unsp2;
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Header, {
            title: "Contact Us",
            image: (_this$props$data$unsp = this.props.data.unsplash.edges.find(function (e) {
                return e.node.name === "home-main";
            })) === null || _this$props$data$unsp === void 0 ? void 0 : (_this$props$data$unsp2 = _this$props$data$unsp.node.childImageSharp) === null || _this$props$data$unsp2 === void 0 ? void 0 : _this$props$data$unsp2.fluid
        }), /*#__PURE__*/ React.createElement("section", {
            className: "page page--contact"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--center mpt-1"
        }, /*#__PURE__*/ React.createElement("address", null, /*#__PURE__*/ React.createElement("h2", null, "American Softgels, Inc."), "100 Station Street Loyalhanna, PA 15661", /*#__PURE__*/ React.createElement("a", {
            type: "tel",
            href: "tel:8006133348"
        }, "(800)631-3348")), /*#__PURE__*/ React.createElement("iframe", {
            src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3041.787011516098!2d-79.36253058460689!3d40.324884279375794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89cb32bfc8930fb1%3A0x8d70fb22d77c3b70!2s100%20Station%20St%2C%20Mcchesneytown-Loyalhanna%2C%20PA%2015661!5e0!3m2!1sen!2sus!4v1615821732508!5m2!1sen!2su",
            width: "100%",
            height: "450",
            loading: "lazy"
        }))), /*#__PURE__*/ React.createElement(Contact, null), /*#__PURE__*/ React.createElement("div", {
            className: "contact contact--light grid grid--half mb-3 mmb-2"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Plant Manager",
            titlePosition: "center"
        }, /*#__PURE__*/ React.createElement("a", {
            href: "mailto:dan@americansoftgelsinc.com"
        }, "Dan Medley"), /*#__PURE__*/ React.createElement("a", {
            href: "mailto:dan@americansoftgelsinc.com"
        }, "dan@americansoftgelsinc.com")), /*#__PURE__*/ React.createElement(Callout, {
            title: "Quality Assurance",
            titlePosition: "center"
        }, /*#__PURE__*/ React.createElement("a", {
            href: "mailto:amanda@americansoftgelsinc.com"
        }, "Amanda Ridenour"), /*#__PURE__*/ React.createElement("a", {
            href: "mailto:amanda@americansoftgelsinc.com"
        }, "amanda@americansoftgelsinc.com"))));
    };
    return _default;
}(React.Component);
export { _default as default };
var query = "1126389482";
